export class UserModel {
    id = '';
    email = '';
    blocked = false;
}
